import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {AuthenticationService} from '../../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-conditions-remittance',
  templateUrl: './conditions-remittance.component.html',
  styleUrls: ['./conditions-remittance.component.scss']
})
export class ConditionsRemittanceComponent implements OnInit {
  es = environment.es;
  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService

  ) { }

  ngOnInit(): void {
  }
  changeLanguage(language: string) {
    this.authenticationService.setLocale(language);
    this.translate.use(this.getValidLanguage(language));
  }
  getValidLanguage(language: string){
    if (language === 'es' || language === 'en'){
      return language;
    } else {
      return 'en';
    }
  }
}
